module.exports = __webpack_public_path__ + "static/media/demonstration-modules.e1a54de9.mp4";